import { combineReducers } from "@ngrx/store";
import { ThirdPartyState } from "./third-party.state";
import { openAiLinkReducer } from "./open-ai-link/open-ai-link.reducer";

export const thirdPartyReducer = combineReducers<ThirdPartyState>({
    openAiSettings: openAiLinkReducer
});
